require('./lbaViewGrid.scss');

const $inject = [];

const lbaViewGrid = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '='
    },
    bindToController: true,
    controller: 'lbaViewGridCtrl',
    controllerAs: 'vm',
    template: require('./lbaViewGrid.html')
  }
};

lbaViewGrid.$inject = $inject;

export default lbaViewGrid;



// WEBPACK FOOTER //
// ./src/components/lbaViewGrid/lbaViewGridDir.js